/**
 * Single source of truth for Terms of Use and Privacy Policy version strings.
 * Both the anonymous (localStorage) and signed-in (backend) consent paths
 * compare against these constants to determine whether re-consent is required.
 *
 * When policies are updated, increment the relevant version string here.
 * Format: "YYYY-MM-DD"
 */
export const LATEST_TOU_VERSION = "2026-06-01";
export const LATEST_PRIVACY_VERSION = "2026-06-01";

// Summaries of changes displayed in the TermsUpdateModal
export const TOU_POLICY_DIFF = "Updated Section 4 regarding user generated kinematics content licensing and cloud sync backup permissions.";
export const PRIVACY_POLICY_DIFF = "Updated Section 2 to clarify performance instrumentation, Google Analytics event tracking, and local storage state persistence.";
